/* Farmstead pack — world sprites: buildings, seasons & biomes, farming props, items, UI.
   Requires sprites.js. Exposes window.SpriteWorld = { world() } */
(function () {
  const L = window.SpriteLib || globalThis.SpriteLib;
  const { G, px, rect, disc, outline, recolor, hash, flipX } = L;
  const T = 24;
  const grid = (w, h) => G(w || T, h || T);

  /* ================= buildings & structures ================= */
  const plank = (g, x, y, w, h, seam) => {
    rect(g, x, y, w, h, 'b3');
    for (let j = y + 3; j < y + h; j += 4) rect(g, x, j, w, 1, seam || 'b1');
    rect(g, x, y, 2, h, 'b4'); rect(g, x + w - 2, y, 2, h, 'b2');
  };
  const shingles = (g, x, y, w, h, a, b) => {
    for (let j = 0; j < h; j++) rect(g, x, y + j, w, 1, j % 4 === 0 ? b : j % 4 === 3 ? 'b1' : a);
  };
  const window2 = (g, x, y, w, h) => {
    rect(g, x, y, w, h, 'K'); rect(g, x + 1, y + 1, w - 2, h - 2, 'c2');
    rect(g, x + Math.floor(w / 2) - 1, y + 1, 2, h - 2, 'K');
    rect(g, x + 1, y + Math.floor(h / 2), w - 2, 1, 'K');
    rect(g, x + 2, y + 2, 3, 2, 'w');
  };

  function mailbox() {
    const g = grid(16, 28);
    rect(g, 6, 12, 4, 16, 'b3'); rect(g, 6, 12, 1, 16, 'b4');
    rect(g, 3, 4, 11, 8, 'n2'); rect(g, 3, 4, 11, 1, 'n3'); rect(g, 3, 10, 11, 2, 'n1');
    rect(g, 11, 5, 2, 6, 'n1'); px(g, 4, 7, 'n3');
    rect(g, 13, 2, 2, 5, 'r1'); rect(g, 13, 2, 1, 5, 'r2');
    outline(g, 'K'); return g;
  }

  function chest() {
    const g = grid(24, 22);
    rect(g, 2, 8, 20, 13, 'b3'); rect(g, 2, 8, 20, 1, 'b4'); rect(g, 2, 19, 20, 2, 'b1');
    rect(g, 2, 3, 20, 5, 'b3'); rect(g, 2, 3, 20, 1, 'b4');
    rect(g, 2, 6, 20, 1, 'b4'); rect(g, 2, 7, 20, 1, 'b1');
    rect(g, 5, 3, 2, 18, 'b2'); rect(g, 17, 3, 2, 18, 'b2');
    rect(g, 10, 7, 4, 5, 'y1'); rect(g, 10, 7, 4, 1, 'y2'); px(g, 12, 10, 'b1');
    outline(g, 'K'); return g;
  }

  function scarecrow(f) {
    const g = grid(24, 48);
    rect(g, 11, 18, 3, 30, 'b3'); rect(g, 11, 18, 1, 30, 'b4');
    rect(g, 3, 20, 19, 3, 'b3'); rect(g, 3, 20, 19, 1, 'b4');
    // straw body
    rect(g, 8, 22, 9, 14, 'b4'); rect(g, 8, 22, 9, 1, 'w');
    for (let i = 0; i < 8; i++) px(g, 8 + i * 1.2 | 0, 36 + (i % 3), 'b3');
    // burlap head
    disc(g, 12, 14, 5, 5, 'b2'); disc(g, 11, 12, 2, 1.6, 'b3');
    px(g, 10, 14, 'K'); px(g, 14, 14, 'K'); rect(g, 11, 17, 3, 1, 'K');
    rect(g, 8, 8, 9, 2, 'b3'); rect(g, 10, 5, 5, 3, 'b4');
    // rag + wind shift
    const s = f ? 1 : 0;
    rect(g, 3 + s, 23, 4, 6, 'r1'); rect(g, 3 + s, 23, 4, 1, 'r2');
    rect(g, 18 - s, 23, 3, 5, 'r1');
    for (let i = 0; i < 5; i++) px(g, 4 + i + s, 21 + (i % 2), 'b4');
    outline(g, 'K'); return g;
  }

  function sprinkler() {
    const g = grid(24, 20);
    rect(g, 6, 12, 12, 7, 'n1'); rect(g, 6, 12, 12, 1, 'n2');
    rect(g, 10, 5, 4, 8, 'n2'); rect(g, 10, 5, 1, 8, 'n3');
    rect(g, 8, 3, 8, 3, 'n2'); rect(g, 8, 3, 8, 1, 'n3');
    px(g, 16, 4, 'c2'); px(g, 17, 5, 'c2');
    outline(g, 'K'); return g;
  }

  function sprinklerSpray(f) {
    const g = grid();
    const arc = (dir) => {
      for (let i = 1; i <= 8; i++) {
        const x = 12 + dir * i, y = 10 + Math.round(Math.pow(i - 4 + f, 2) * 0.18);
        if ((i + f) % 2) px(g, x, y, 'cA'); else px(g, x, y, 'wA');
      }
    };
    arc(1); arc(-1);
    for (let i = 0; i < 4; i++) { px(g, 12 + (i % 2 ? 3 : -3) + f, 6 + i * (1 + f), i % 2 ? 'cA' : 'wA'); }
    if (f === 2) { rect(g, 7, 19, 11, 1, 'cB'); }
    return g;
  }

  function gate(open) {
    const g = grid();
    if (!open) {
      rect(g, 0, 9, T, 3, 'b3'); rect(g, 0, 9, T, 1, 'b4');
      rect(g, 0, 15, T, 3, 'b3'); rect(g, 0, 15, T, 1, 'b4');
      for (let i = 0; i < 12; i++) px(g, 5 + i, 18 - i, 'b2');
      rect(g, 1, 7, 3, 15, 'b3'); rect(g, 20, 7, 3, 15, 'b3');
    } else {
      for (let i = 0; i < 18; i++) { const y = 16 - Math.round(i * 0.35); rect(g, 4 + i, y, 1, 3, 'b3'); px(g, 4 + i, y, 'b4'); }
      for (let i = 0; i < 18; i++) { const y = 21 - Math.round(i * 0.35); rect(g, 4 + i, y, 1, 2, 'b3'); }
      rect(g, 1, 7, 3, 15, 'b3'); rect(g, 1, 7, 1, 15, 'b4');
    }
    outline(g, 'K'); return g;
  }

  function coop() {
    const g = grid(72, 56);
    shingles(g, 2, 6, 68, 14, 'r1', 'r2');
    rect(g, 0, 5, 72, 2, 'b1');
    plank(g, 6, 20, 60, 34);
    rect(g, 4, 54, 64, 2, 'b1');
    window2(g, 44, 26, 14, 12);
    rect(g, 14, 38, 12, 16, 'K'); rect(g, 15, 39, 10, 15, 'D');
    rect(g, 12, 52, 16, 4, 'b4'); rect(g, 12, 52, 16, 1, 'w');
    outline(g, 'K'); return g;
  }

  function feedTrough() {
    const g = grid(24, 16);
    rect(g, 1, 6, 22, 9, 'b2'); rect(g, 1, 6, 22, 1, 'b3'); rect(g, 1, 13, 22, 2, 'b1');
    rect(g, 3, 5, 18, 3, 'y1'); rect(g, 4, 4, 6, 1, 'y2'); rect(g, 13, 4, 5, 1, 'y2');
    outline(g, 'K'); return g;
  }

  function barn() {
    const g = grid(96, 80);
    // gambrel roof
    for (let y = 4; y <= 26; y++) {
      const half = y < 14 ? Math.round((y - 4) * 2.2) + 8 : Math.round(22 + (y - 14) * 1.6);
      const x0 = Math.max(1, 48 - half), x1 = Math.min(94, 47 + half);
      rect(g, x0, y, x1 - x0 + 1, 1, (y - 4) % 4 === 0 ? 'r2' : (y - 4) % 4 === 3 ? 'b1' : 'r1');
    }
    rect(g, 44, 3, 8, 2, 'b1');
    rect(g, 4, 26, 88, 50, 'r1');
    for (let y = 29; y < 76; y += 5) rect(g, 4, y, 88, 1, 'r2');
    rect(g, 4, 26, 3, 50, 'w'); rect(g, 89, 26, 3, 50, 'w');
    rect(g, 4, 74, 88, 2, 'w');
    // hayloft
    rect(g, 40, 14, 16, 12, 'K'); rect(g, 41, 15, 14, 10, 'D');
    rect(g, 42, 21, 12, 4, 'b4'); px(g, 44, 20, 'b4'); px(g, 51, 20, 'b4');
    // double doors with X brace
    rect(g, 30, 42, 36, 34, 'b1'); rect(g, 31, 43, 16, 32, 'b2'); rect(g, 49, 43, 16, 32, 'b2');
    for (let i = 0; i < 16; i++) { px(g, 31 + i, 43 + i * 2, 'b1'); px(g, 46 - i, 43 + i * 2, 'b1'); px(g, 49 + i, 43 + i * 2, 'b1'); px(g, 64 - i, 43 + i * 2, 'b1'); }
    rect(g, 47, 42, 2, 34, 'b1');
    rect(g, 2, 76, 92, 3, 'b4'); rect(g, 2, 79, 92, 1, 'b1');
    outline(g, 'K'); return g;
  }

  function shop() {
    const g = grid(72, 72);
    shingles(g, 2, 4, 68, 12, 'r1', 'r2');
    plank(g, 6, 16, 60, 52);
    // striped awning
    for (let i = 0; i < 60; i++) rect(g, 6 + i, 28, 1, 6, (i % 8) < 4 ? 'g2' : 'w');
    rect(g, 6, 34, 60, 1, 'b1');
    window2(g, 12, 40, 26, 20);
    rect(g, 44, 40, 16, 28, 'b1'); rect(g, 45, 41, 14, 27, 'b2'); px(g, 56, 54, 'y1');
    // hanging sign
    rect(g, 20, 18, 22, 8, 'b4'); rect(g, 20, 18, 22, 1, 'w');
    rect(g, 24, 21, 5, 2, 'K'); rect(g, 31, 21, 8, 2, 'K');
    rect(g, 30, 16, 2, 2, 'n1');
    rect(g, 2, 68, 68, 3, 'b4'); rect(g, 2, 71, 68, 1, 'b1');
    outline(g, 'K'); return g;
  }

  function greenhouse() {
    const g = grid(96, 72);
    // frame + glass roof
    for (let y = 6; y <= 22; y++) {
      const half = Math.round((y - 6) * 2.4) + 6;
      const x0 = Math.max(2, 48 - half), x1 = Math.min(93, 47 + half);
      rect(g, x0, y, x1 - x0 + 1, 1, 'c2');
    }
    for (let x = 8; x < 90; x += 10) for (let y = 8; y <= 22; y++) px(g, x, y, 'n2');
    rect(g, 4, 22, 88, 44, 'c2');
    for (let x = 8; x < 92; x += 10) rect(g, x, 22, 2, 44, 'n2');
    for (let y = 30; y < 66; y += 12) rect(g, 4, y, 88, 2, 'n2');
    // glare + foliage inside
    for (let i = 0; i < 18; i++) px(g, 14 + i, 26 + i, 'w');
    for (let i = 0; i < 14; i++) px(g, 60 + i, 30 + i, 'w');
    for (let x = 10; x < 88; x += 9) { disc(g, x, 58, 4, 3, 'g2'); disc(g, x, 56, 2.4, 2, 'g3'); }
    rect(g, 2, 20, 92, 2, 'n1'); rect(g, 2, 66, 92, 4, 'n1'); rect(g, 2, 66, 92, 1, 'n3');
    rect(g, 40, 40, 16, 26, 'n1'); rect(g, 41, 41, 14, 25, 'c2'); rect(g, 47, 41, 2, 25, 'n1');
    outline(g, 'K'); return g;
  }

  function well() {
    const g = grid(24, 34);
    rect(g, 2, 20, 20, 12, 'n2');
    for (let y = 20; y < 32; y += 3) for (let x = 2; x < 22; x += 5) { px(g, x + (y % 6 ? 2 : 0), y, 'n1'); rect(g, x + (y % 6 ? 2 : 0), y, 4, 1, 'n1'); }
    rect(g, 2, 20, 20, 2, 'n3'); rect(g, 2, 30, 20, 2, 'n1');
    rect(g, 4, 4, 3, 18, 'b3'); rect(g, 17, 4, 3, 18, 'b3');
    rect(g, 3, 2, 18, 3, 'b3'); rect(g, 3, 2, 18, 1, 'b4');
    rect(g, 6, 5, 12, 2, 'b2');
    rect(g, 11, 7, 1, 6, 'w');
    rect(g, 9, 13, 6, 5, 'b2'); rect(g, 9, 13, 6, 1, 'b3'); rect(g, 9, 17, 6, 1, 'b1');
    outline(g, 'K'); return g;
  }

  function caveEntrance() {
    const g = grid(48, 48);
    disc(g, 24, 44, 21, 26, 'n1');
    disc(g, 24, 46, 15, 20, 'K');
    for (let y = 10; y < 48; y += 4) for (let x = 4; x < 44; x += 6) if (hash(x, y, 3) > 0.5) px(g, x, y, 'n2');
    disc(g, 16, 22, 3, 2, 'n2'); disc(g, 33, 26, 3, 2, 'n2');
    for (const [x, y, r] of [[8, 45, 3], [14, 46, 2], [36, 45, 3], [42, 46, 2], [24, 47, 2]]) disc(g, x, y, r, r * 0.6, 'n3');
    outline(g, 'K'); return g;
  }

  function bridge(vertical) {
    const g = grid();
    if (!vertical) {
      for (let y = 4; y < 20; y++) rect(g, 0, y, T, 1, (y - 4) % 4 === 3 ? 'b1' : 'b3');
      rect(g, 0, 4, T, 1, 'b4'); rect(g, 0, 19, T, 1, 'b1');
      rect(g, 0, 1, T, 2, 'b4'); rect(g, 0, 21, T, 2, 'b4');
      for (let x = 2; x < T; x += 8) { rect(g, x, 0, 2, 4, 'b3'); rect(g, x, 20, 2, 4, 'b3'); }
    } else {
      for (let x = 4; x < 20; x++) rect(g, x, 0, 1, T, (x - 4) % 4 === 3 ? 'b1' : 'b3');
      rect(g, 4, 0, 1, T, 'b4'); rect(g, 19, 0, 1, T, 'b1');
      rect(g, 1, 0, 2, T, 'b4'); rect(g, 21, 0, 2, T, 'b4');
      for (let y = 2; y < T; y += 8) { rect(g, 0, y, 4, 2, 'b3'); rect(g, 20, y, 4, 2, 'b3'); }
    }
    return g;
  }

  function dock(end) {
    const g = grid();
    for (let y = 0; y < (end ? 20 : T); y++) rect(g, 0, y, T, 1, y % 4 === 3 ? 'b1' : 'b3');
    rect(g, 0, 0, T, 1, 'b4');
    if (end) { rect(g, 0, 20, T, 1, 'b1'); rect(g, 2, 21, 3, 3, 'b1'); rect(g, 19, 21, 3, 3, 'b1'); }
    else { rect(g, 3, 8, 3, 3, 'b1'); rect(g, 18, 16, 3, 3, 'b1'); }
    return g;
  }

  function sign(forsale) {
    const g = grid();
    rect(g, 11, 12, 3, 12, 'b3'); rect(g, 11, 12, 1, 12, 'b4');
    rect(g, 2, 3, 20, 11, 'b3'); rect(g, 2, 3, 20, 1, 'b4'); rect(g, 2, 12, 20, 2, 'b1');
    if (forsale) { rect(g, 5, 6, 14, 2, 'w'); rect(g, 5, 9, 9, 2, 'w'); }
    else { rect(g, 6, 7, 12, 1, 'b1'); rect(g, 6, 10, 8, 1, 'b1'); }
    outline(g, 'K'); return g;
  }

  function hayBale() {
    const g = grid(24, 20);
    rect(g, 2, 4, 20, 15, 'b4');
    for (let y = 5; y < 19; y += 2) for (let x = 3; x < 21; x += 3) px(g, x + (y % 4 ? 1 : 0), y, 'b3');
    rect(g, 7, 4, 2, 15, 'b3'); rect(g, 16, 4, 2, 15, 'b3');
    rect(g, 2, 4, 20, 1, 'w');
    px(g, 4, 2, 'y1'); px(g, 12, 2, 'y1'); px(g, 19, 3, 'y1');
    outline(g, 'K'); return g;
  }

  /* ================= terrain: seasons & biomes ================= */
  const SEASON = {
    summer: { g1: 'g2', g2: 'g3', g3: 'g4', g4: 'y2' },
    autumn: { g1: 'b2', g2: 'b3', g3: 'y1', g4: 'y2' },
    winter: { g1: 'b1', g2: 'b2', g3: 'n3', g4: 'w' }
  };

  function grassSeason(season, seed) {
    const g = window.SpriteLib.__grass(seed);
    recolor(g, SEASON[season]);
    if (season === 'summer') for (let i = 0; i < 6; i++) px(g, (i * 7 + 3) % T, (i * 5 + 2) % T, 'y1');
    if (season === 'autumn') for (let i = 0; i < 6; i++) { const x = (i * 9 + 2) % T, y = (i * 6 + 4) % T; px(g, x, y, 'r2'); px(g, x + 1, y, 'r1'); }
    if (season === 'winter') for (let i = 0; i < 9; i++) { const x = (i * 5 + 1) % T, y = (i * 7 + 3) % T; px(g, x, y, 'b1'); px(g, x, (y + 1) % T, 'b2'); }
    return g;
  }

  function snow(seed) {
    const g = grid();
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) {
      const p = 0.6 * hash(Math.floor(x / 5), Math.floor(y / 5), seed) + 0.4 * hash(x, y, seed + 1);
      px(g, x, y, p > 0.72 ? 'n3' : 'w');
    }
    for (let y = 0; y < T; y += 6) for (let x = 0; x < T; x++) if (hash(x, y, seed + 3) > 0.6) px(g, x, y + (x % 3 === 0 ? 1 : 0), 'n3');
    px(g, (seed * 7) % T, (seed * 11) % T, 'c2');
    return g;
  }

  function ice() {
    const g = grid();
    rect(g, 0, 0, T, T, 'c2');
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) if (hash(x, y, 31) > 0.85) px(g, x, y, 'w');
    // plates + cracks
    for (let i = 0; i < T; i++) { px(g, i, (i * 2) % T, 'K'); px(g, (i * 3) % T, i, 'K'); }
    for (let i = 0; i < 8; i++) rect(g, (i * 5) % T, (i * 7) % T, 3, 1, 'w');
    return g;
  }

  function sand() {
    const g = grid();
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) {
      const h = hash(x, y, 41);
      px(g, x, y, h > 0.9 ? 'w' : h > 0.72 ? 'b3' : 'b4');
    }
    for (let i = 0; i < 3; i++) { const x = (i * 9 + 4) % T, y = (i * 7 + 5) % T; px(g, x, y, 'w'); px(g, x + 1, y, 'n3'); }
    return g;
  }

  function caveFloor(seed) {
    const g = grid();
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) {
      const h = hash(x, y, seed + 50);
      px(g, x, y, h > 0.88 ? 'n2' : h < 0.1 ? 'K' : 'n1');
    }
    if (seed === 3) { px(g, 9, 14, 'y1'); px(g, 10, 15, 'y1'); }
    for (let i = 0; i < 5; i++) { const x = (i * 7 + 2) % T, y = (i * 5 + 3) % T; rect(g, x, y, 2, 1, 'n2'); }
    return g;
  }

  function caveWall() {
    const g = grid();
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) {
      const h = hash(x, y, 60);
      px(g, x, y, h > 0.9 ? 'n1' : h > 0.55 ? 'D' : 'K');
    }
    for (let x = 0; x < T; x++) px(g, x, (x % 4 === 0 ? 1 : 0), 'n1');
    rect(g, 0, 0, T, 1, 'n1');
    return g;
  }

  function flowerPatch(seed) {
    const g = grid();
    const cols = ['r2', 'y2', 'p2', 'w'];
    for (let i = 0; i < 6; i++) {
      const x = 3 + ((i * 7 + seed * 3) % 18), y = 8 + ((i * 5 + seed * 2) % 12);
      rect(g, x, y + 1, 1, 3, 'g1');
      px(g, x, y, cols[(i + seed) % 4]); px(g, x - 1, y, cols[(i + seed) % 4]); px(g, x + 1, y, cols[(i + seed) % 4]);
      px(g, x, y - 1, cols[(i + seed + 1) % 4]); px(g, x, y + 1, 'y1');
    }
    return g;
  }

  function pathGravel() {
    const g = grid();
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) {
      const h = hash(x, y, 71);
      px(g, x, y, h > 0.88 ? 'n3' : h > 0.6 ? 'n2' : 'n1');
    }
    for (let i = 0; i < 6; i++) { const x = (i * 7 + 2) % T, y = (i * 5 + 1) % T; rect(g, x, y, 2, 2, 'n3'); px(g, x, y + 2, 'n1'); }
    return g;
  }

  function pathPlank() {
    const g = grid();
    for (let y = 0; y < T; y++) rect(g, 0, y, T, 1, y % 6 === 0 ? 'b1' : y % 6 === 1 ? 'b3' : 'b2');
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) if (hash(x, y, 81) > 0.92) px(g, x, y, 'b3');
    return g;
  }

  /* ================= farming props ================= */
  function weed(v) {
    const g = grid();
    for (let i = 0; i < 5 + v; i++) {
      const x = 6 + ((i * 5 + v * 3) % 12), h = 4 + ((i * 3 + v) % 5);
      for (let j = 0; j < h; j++) px(g, x + (j > h / 2 ? (i % 2 ? 1 : -1) : 0), 19 - j, j > h - 2 ? 'g2' : 'g1');
    }
    if (v === 2) { disc(g, 12, 10, 2, 2.4, 'p2'); px(g, 12, 8, 'p1'); }
    if (v === 1) { px(g, 8, 12, 'g2'); px(g, 16, 13, 'g2'); }
    rect(g, 4, 20, 16, 1, 'b2');
    outline(g, 'K'); return g;
  }

  function soilFertilised(wet) {
    const g = window.SpriteLib.__tilled(wet);
    for (let y = 0; y < T; y++) for (let x = 0; x < T; x++) if (hash(x, y, wet ? 91 : 90) > 0.9) px(g, x, y, 'D');
    return g;
  }

  function star(gold) {
    const g = grid(8, 8);
    const c = gold ? 'y1' : 'n3', hi = gold ? 'y2' : 'w';
    rect(g, 3, 0, 2, 8, c); rect(g, 0, 3, 8, 2, c);
    px(g, 2, 2, c); px(g, 5, 2, c); px(g, 2, 5, c); px(g, 5, 5, c);
    px(g, 3, 3, hi); px(g, 4, 3, hi);
    outline(g, 'K'); return g;
  }

  function trellis() {
    const g = grid();
    rect(g, 3, 4, 2, 20, 'b3'); rect(g, 19, 4, 2, 20, 'b3');
    rect(g, 3, 4, 18, 2, 'b3'); rect(g, 3, 5, 18, 1, 'b1');
    for (let x = 7; x < 20; x += 4) { rect(g, x, 6, 1, 18, 'b2'); }
    for (let y = 10; y < 24; y += 6) rect(g, 4, y, 17, 1, 'b2');
    outline(g, 'K'); return g;
  }

  function tree(kind, stage) {
    const g = grid(32, 44);
    const trunk = (h, w) => { rect(g, 16 - Math.floor(w / 2), 44 - h, w, h, 'b2'); rect(g, 16 - Math.floor(w / 2), 44 - h, 1, h, 'b3'); rect(g, 15 + Math.ceil(w / 2), 44 - h, 1, h, 'b1'); };
    if (stage === 0) { trunk(10, 2); disc(g, 16, 32, 3, 3, 'g3'); disc(g, 16, 31, 2, 2, 'g4'); px(g, 13, 34, 'g2'); }
    if (stage === 1) { trunk(16, 3); disc(g, 16, 24, 7, 6, 'g2'); disc(g, 14, 22, 4, 3.5, 'g3'); }
    if (stage >= 2 && stage <= 3) {
      trunk(20, 6);
      disc(g, 16, 16, 14, 12, 'g2');
      disc(g, 13, 13, 9, 7, 'g3'); disc(g, 11, 11, 5, 4, 'g4');
      for (let i = 0; i < 8; i++) px(g, 4 + i * 3, 26 - (i % 3), 'g1');
      if (stage === 3) {
        const f = kind === 'apple' ? 'r1' : 'r2', fh = kind === 'apple' ? 'r2' : 'w';
        for (const [x, y] of [[8, 14], [14, 10], [21, 15], [17, 21], [11, 21], [24, 9]]) {
          disc(g, x, y, 2, 2, f); px(g, x - 1, y - 1, fh); px(g, x, y - 2, 'g2');
        }
        if (kind === 'cherry') for (const [x, y] of [[6, 9], [19, 6], [26, 17]]) { disc(g, x, y, 2, 1.6, 'w'); px(g, x, y, 'p2'); }
      }
    }
    if (stage === 4) {
      trunk(22, 6);
      const limb = (x0, y0, x1, y1) => { const n = Math.max(Math.abs(x1 - x0), Math.abs(y1 - y0)); for (let i = 0; i <= n; i++) { const x = Math.round(x0 + (x1 - x0) * i / n), y = Math.round(y0 + (y1 - y0) * i / n); px(g, x, y, 'b2'); px(g, x + 1, y, 'b1'); } };
      limb(16, 22, 6, 10); limb(16, 22, 26, 9); limb(16, 20, 12, 5); limb(16, 20, 21, 4);
      limb(10, 15, 4, 12); limb(22, 14, 28, 12);
      if (kind === 'cherry') { px(g, 8, 9, 'w'); px(g, 24, 8, 'w'); }
    }
    outline(g, 'K'); return g;
  }

  /* ================= items & UI ================= */
  function item(id) {
    const g = grid();
    const sack = (tag) => {
      disc(g, 12, 16, 7, 6, 'b4'); disc(g, 9, 15, 3, 3.5, 'w');
      rect(g, 9, 7, 6, 4, 'b3'); rect(g, 8, 9, 8, 2, 'b2');
      rect(g, 10, 5, 4, 2, 'b4');
      rect(g, 9, 15, 6, 3, tag); rect(g, 9, 15, 6, 1, 'w');
    };
    if (id === 'egg') { disc(g, 12, 14, 5, 7, 'w'); disc(g, 10, 11, 2, 3, 'w'); disc(g, 14, 17, 3, 3, 'b4'); px(g, 10, 10, 'w'); }
    if (id === 'milk') {
      rect(g, 6, 8, 12, 12, 'n2'); rect(g, 6, 8, 12, 1, 'n3'); rect(g, 6, 18, 12, 2, 'n1');
      rect(g, 7, 9, 10, 3, 'w'); rect(g, 5, 6, 14, 2, 'n1'); rect(g, 8, 4, 2, 3, 'n2'); rect(g, 14, 4, 2, 3, 'n2');
      rect(g, 8, 3, 8, 2, 'n3');
    }
    if (id === 'fish_bass') { disc(g, 12, 12, 8, 4, 'g2'); disc(g, 10, 11, 5, 2.4, 'c1'); rect(g, 19, 9, 4, 6, 'g2'); px(g, 7, 11, 'K'); rect(g, 11, 8, 4, 2, 'g1'); }
    if (id === 'fish_carp') { disc(g, 12, 12, 8, 4.5, 'y1'); disc(g, 11, 11, 5, 2.4, 'b3'); rect(g, 19, 9, 4, 7, 'y1'); px(g, 7, 11, 'K'); px(g, 9, 15, 'b3'); }
    if (id === 'fish_trout') { disc(g, 12, 12, 8, 4, 'r2'); disc(g, 11, 13, 5, 2, 'w'); rect(g, 19, 9, 4, 6, 'r1'); px(g, 7, 11, 'K'); for (let i = 0; i < 4; i++) px(g, 9 + i * 2, 10, 'r1'); }
    if (id === 'fish_boot') { rect(g, 6, 6, 7, 12, 'b2'); rect(g, 6, 14, 15, 5, 'b2'); rect(g, 6, 6, 7, 1, 'b3'); rect(g, 6, 18, 15, 2, 'b1'); px(g, 18, 15, 'b3'); px(g, 9, 10, 'b1'); }
    if (id === 'mushroom') { disc(g, 12, 10, 7, 5, 'r1'); disc(g, 10, 8, 3, 2, 'r2'); px(g, 9, 10, 'w'); px(g, 14, 9, 'w'); px(g, 12, 12, 'w'); rect(g, 10, 14, 4, 7, 'w'); rect(g, 10, 14, 1, 7, 'b4'); }
    if (id === 'berry') { for (const [x, y] of [[10, 10], [14, 11], [12, 14], [16, 15], [9, 15]]) { disc(g, x, y, 2, 2, 'p1'); px(g, x - 1, y - 1, 'p2'); } rect(g, 12, 6, 1, 4, 'g2'); px(g, 11, 7, 'g3'); px(g, 14, 8, 'g3'); }
    if (id === 'stick') { for (let i = 0; i < 14; i++) { px(g, 5 + i, 17 - i, 'b3'); px(g, 6 + i, 17 - i, 'b2'); } px(g, 12, 9, 'b2'); px(g, 13, 8, 'b3'); px(g, 9, 15, 'b2'); }
    if (id === 'stone') { disc(g, 12, 14, 8, 6, 'n2'); disc(g, 10, 12, 4, 3, 'n3'); disc(g, 15, 17, 3, 2, 'n1'); }
    if (id === 'fertiliser_basic') sack('g3');
    if (id === 'fertiliser_quality') { sack('y1'); px(g, 12, 13, 'y2'); }
    if (id === 'feed') { sack('b4'); px(g, 11, 14, 'y1'); px(g, 13, 14, 'y1'); }
    if (id === 'ore_copper' || id === 'ore_iron' || id === 'ore_gold') {
      const vein = id === 'ore_copper' ? 'r2' : id === 'ore_iron' ? 'n3' : 'y1';
      disc(g, 12, 14, 8, 6, 'n2'); disc(g, 10, 12, 4, 3.4, 'n1');
      for (const [x, y] of [[9, 12], [14, 11], [12, 16], [16, 15]]) { disc(g, x, y, 1.6, 1.4, vein); px(g, x - 1, y - 1, id === 'ore_gold' ? 'y2' : 'w'); }
    }
    outline(g, 'K'); return g;
  }

  function ui(id) {
    if (id === 'energy_full' || id === 'energy_empty') {
      const g = grid(8, 8);
      if (id === 'energy_full') {
        rect(g, 0, 0, 8, 8, 'K'); rect(g, 1, 1, 6, 6, 'g3');
        rect(g, 1, 1, 6, 1, 'g4'); rect(g, 1, 6, 6, 1, 'g2');
      } else {
        rect(g, 0, 0, 8, 8, 'K'); rect(g, 1, 1, 6, 6, 'D'); rect(g, 1, 1, 6, 1, 'n1');
      }
      outline(g, 'K'); return g;
    }
    if (id === 'coin') {
      const g = grid(12, 12);
      disc(g, 6, 6, 5, 5, 'y1'); disc(g, 4, 4, 2.4, 2.4, 'y2'); rect(g, 5, 3, 2, 6, 'b3');
      outline(g, 'K'); return g;
    }
    if (id === 'star') {
      const g = grid(12, 12);
      // same silhouette as star_silver/gold: arms plus diagonal corner pixels
      const rows = [
        '.....##.....',
        '.....##.....',
        '....####....',
        '....####....',
        '.##########.',
        '..########..',
        '..########..',
        '..###..###..',
        '.###....###.',
        '.##......##.',
        '............',
        '............'
      ];
      rows.forEach((r, y) => r.split('').forEach((c, x) => { if (c === '#') px(g, x, y, y > 6 ? 'y1' : 'y2'); }));
      px(g, 5, 3, 'w'); px(g, 4, 4, 'w');
      outline(g, 'K'); return g;
    }
    if (id.startsWith('weather_')) {
      const g = grid(16, 16);
      const kind = id.slice(8);
      if (kind === 'sun') { disc(g, 8, 8, 4, 4, 'y1'); disc(g, 7, 7, 2, 2, 'y2'); for (const [x, y] of [[8, 1], [8, 14], [1, 8], [14, 8], [3, 3], [12, 12], [12, 3], [3, 12]]) px(g, x, y, 'y1'); }
      if (kind === 'rain') { disc(g, 8, 6, 6, 3.4, 'n3'); disc(g, 6, 5, 3, 2, 'w'); for (let i = 0; i < 4; i++) { px(g, 3 + i * 3, 11, 'c2'); px(g, 3 + i * 3, 13, 'c2'); } }
      if (kind === 'storm') { disc(g, 8, 6, 6, 3.4, 'n1'); disc(g, 6, 5, 3, 2, 'n2'); for (let i = 0; i < 4; i++) px(g, 8 + (i % 2 ? 1 : -1), 10 + i, 'y2'); px(g, 6, 13, 'y1'); }
      if (kind === 'snow') { disc(g, 8, 6, 6, 3.4, 'n3'); disc(g, 6, 5, 3, 2, 'w'); for (const [x, y] of [[4, 11], [8, 13], [12, 11], [6, 14], [10, 10]]) { px(g, x, y, 'w'); px(g, x + 1, y, 'n3'); } }
      outline(g, 'K'); return g;
    }
    if (id === 'bubble_talk' || id === 'bubble_exclaim') {
      const g = grid(16, 16);
      rect(g, 1, 2, 14, 9, 'w'); rect(g, 2, 11, 5, 3, 'w'); px(g, 3, 14, 'w');
      if (id === 'bubble_talk') { for (let i = 0; i < 3; i++) rect(g, 3 + i * 4, 6, 2, 2, 'K'); }
      else { rect(g, 7, 4, 2, 4, 'K'); rect(g, 7, 9, 2, 1, 'K'); }
      outline(g, 'K'); return g;
    }
    if (id === 'touch_dpad') {
      const g = grid(48, 48);
      rect(g, 16, 4, 16, 40, 'D'); rect(g, 4, 16, 40, 16, 'D');
      rect(g, 18, 6, 12, 36, 'n1'); rect(g, 6, 18, 36, 12, 'n1');
      const tri = (cx, cy, dx, dy) => { for (let i = 0; i < 5; i++) for (let j = -i; j <= i; j++) px(g, cx + dx * i + (dx ? 0 : j), cy + dy * i + (dy ? 0 : j), 'w'); };
      tri(24, 14, 0, -1); tri(24, 34, 0, 1); tri(14, 24, -1, 0); tri(34, 24, 1, 0);
      outline(g, 'K'); return g;
    }
    if (id === 'touch_button') {
      const g = grid(48, 48);
      disc(g, 24, 24, 20, 20, 'D'); disc(g, 24, 24, 17, 17, 'n1');
      disc(g, 19, 19, 7, 7, 'n2');
      rect(g, 20, 20, 8, 8, 'w');
      outline(g, 'K'); return g;
    }
    return grid();
  }

  /* ================= FX remainder ================= */
  function fxRain(f) {
    const g = grid();
    for (let i = 0; i < 14; i++) {
      const x0 = (i * 7 + f * 6) % T, y0 = (i * 5 + f * 7) % T;
      for (let j = 0; j < 4; j++) px(g, (x0 + j) % T, (y0 + j * 2) % T, j < 2 ? 'cA' : 'cB');
    }
    return g;
  }
  function fxSnow(f) {
    const g = grid();
    for (let i = 0; i < 10; i++) {
      const x = (i * 9 + f * 3) % T, y = (i * 7 + f * 6) % T;
      px(g, x, y, 'wA'); if (i % 3 === 0) { px(g, x + 1, y, 'wA'); px(g, x, y + 1, 'wB'); }
    }
    for (let i = 0; i < 6; i++) px(g, (i * 5 + f * 2) % T, (i * 11 + f * 4) % T, 'wB');
    return g;
  }
  function fxPuddle() {
    const g = grid();
    disc(g, 12, 17, 10, 5, 'cB'); disc(g, 12, 17, 8, 3.6, 'cA');
    disc(g, 9, 15, 3, 1.4, 'wA');
    for (let i = 0; i < 10; i++) px(g, 4 + i * 2, 12 + (i % 2 ? 0 : 1), 'wB');
    return g;
  }
  function fxZzz(f) {
    const g = grid(16, 16);
    const z = (x, y, s, c) => { rect(g, x, y, s, 1, c); rect(g, x, y + s - 1, s, 1, c); for (let i = 0; i < s; i++) px(g, x + s - 1 - i, y + i, c); };
    z(2 + f, 10 - f * 2, 4, 'wA');
    if (f >= 1) z(7 + f, 5 - f, 3, f === 2 ? 'wB' : 'wA');
    if (f === 2) z(11, 1, 3, 'wB');
    return g;
  }
  function fxBobber() {
    const g = grid(8, 8);
    disc(g, 4, 4, 3, 3, 'r1'); disc(g, 3, 3, 1.6, 1.6, 'w');
    rect(g, 3, 0, 2, 2, 'w');
    outline(g, 'K'); return g;
  }
  function fxRipple(f) {
    const g = grid();
    const r = 4 + f * 4;
    for (let a = 0; a < 40; a++) {
      const th = a / 40 * Math.PI * 2;
      px(g, 12 + Math.round(Math.cos(th) * r), 14 + Math.round(Math.sin(th) * r * 0.5), f === 2 ? 'cB' : 'cA');
    }
    if (f === 0) px(g, 12, 14, 'wA');
    return g;
  }
  function fxLightning() {
    const g = grid(48, 72);
    let x = 26;
    for (let y = 0; y < 72; y++) {
      x += hash(y, 1, 99) > 0.5 ? 1 : -1;
      if (y % 9 === 0) x += hash(y, 2, 98) > 0.5 ? 3 : -3;
      rect(g, x - 2, y, 4, 1, 'wA'); rect(g, x - 1, y, 2, 1, 'w'); px(g, x + 2, y, 'cA'); px(g, x - 3, y, 'cA');
      if (y === 40) for (let i = 0; i < 14; i++) { px(g, x + 3 + i, y + i, 'wA'); px(g, x + 3 + i, y + i + 1, 'cA'); }
    }
    return g;
  }
  function fxLampGlow() {
    const g = grid(48, 48);
    for (let y = 0; y < 48; y++) for (let x = 0; x < 48; x++) {
      const d = Math.hypot(x - 24, y - 24) / 24;
      if (d > 1) continue;
      px(g, x, y, d < 0.3 ? 'yA' : d < 0.6 ? 'yB' : 'yC');
    }
    return g;
  }

  /* ================= catalog ================= */
  function world() {
    const out = [];
    const add = (cat, id, g, meta) => out.push(Object.assign({ cat, id, grid: g, w: g.w, h: g.h }, meta || {}));
    const G_ = window.SpriteLib.__grass, TIL = window.SpriteLib.__tilled, TR = window.SpriteLib.__transition, FE = window.SpriteLib.__fence;

    // buildings (§3 remainder)
    add('props', 'mailbox', mailbox(), { priority: 'P1' });
    add('props', 'chest', chest(), { priority: 'P1' });
    [0, 1].forEach(f => add('props', 'scarecrow_' + f, scarecrow(f), { priority: 'P1', anim: 'scarecrow', frame: f }));
    add('props', 'sprinkler', sprinkler(), { priority: 'P1' });
    [0, 1, 2].forEach(f => add('fx', 'sprinkler_spray_' + f, sprinklerSpray(f), { priority: 'P1', anim: 'sprinkler_spray', frame: f, blended: true }));
    add('props', 'gate_closed', gate(false), { priority: 'P1' });
    add('props', 'gate_open', gate(true), { priority: 'P1' });
    add('props', 'coop', coop(), { priority: 'P1' });
    add('props', 'feed_trough', feedTrough(), { priority: 'P1' });
    add('props', 'barn', barn(), { priority: 'P2' });
    add('props', 'shop', shop(), { priority: 'P2' });
    add('props', 'greenhouse', greenhouse(), { priority: 'P2' });
    add('props', 'well', well(), { priority: 'P2' });
    add('props', 'cave_entrance', caveEntrance(), { priority: 'P2' });
    add('props', 'bridge_h', bridge(false), { priority: 'P2' });
    add('props', 'bridge_v', bridge(true), { priority: 'P2' });
    add('props', 'dock_mid', dock(false), { priority: 'P2' });
    add('props', 'dock_end', dock(true), { priority: 'P2' });
    add('props', 'sign', sign(false), { priority: 'P2' });
    add('props', 'sign_forsale', sign(true), { priority: 'P2' });
    add('props', 'hay_bale', hayBale(), { priority: 'P2' });

    // terrain (§4)
    ['summer', 'autumn', 'winter'].forEach(s => [1, 2, 3].forEach(i =>
      add('season', `grass_${s}_0${i}`, grassSeason(s, i), { priority: 'P1', season: s })));
    [1, 2, 3].forEach(i => add('season', 'snow_0' + i, snow(i), { priority: 'P1' }));
    ['N', 'E', 'S', 'W', 'NE', 'NW', 'SE', 'SW', 'IN_NE', 'IN_NW', 'IN_SE', 'IN_SW'].forEach(d =>
      add('season', 'snow_to_grass_' + d.toLowerCase(), TR(() => snow(1), () => G_(1), d), { priority: 'P1', autotile: 'snow>grass' }));
    [1, 2, 3].forEach(i => add('season', 'flower_patch_0' + i, flowerPatch(i), { priority: 'P1', overlay: true }));
    add('season', 'path_gravel', pathGravel(), { priority: 'P1' });
    add('season', 'path_plank', pathPlank(), { priority: 'P1' });
    add('season', 'soil_frozen', (() => { const g = TIL(false); recolor(g, { b3: 'n3', b4: 'w' }); for (let y = 0; y < T; y += 6) for (let x = 0; x < T; x++) if (hash(x, y, 95) > 0.5) px(g, x, y + 1, 'w'); return g; })(), { priority: 'P2' });
    add('season', 'ice_water', ice(), { priority: 'P2' });
    ['N', 'E', 'S', 'W', 'NE', 'NW', 'SE', 'SW'].forEach(d =>
      add('season', 'ice_edge_' + d.toLowerCase(), TR(ice, () => snow(1), d), { priority: 'P2', autotile: 'ice>snow' }));
    add('season', 'sand', sand(), { priority: 'P2' });
    ['N', 'E', 'S', 'W', 'NE', 'NW', 'SE', 'SW'].forEach(d =>
      add('season', 'sand_to_water_' + d.toLowerCase(), TR(sand, window.SpriteLib.__water, d), { priority: 'P2', autotile: 'sand>water' }));
    [1, 2, 3].forEach(i => add('season', 'cave_floor_0' + i, caveFloor(i), { priority: 'P2' }));
    add('season', 'cave_wall', caveWall(), { priority: 'P2' });
    ['N', 'E', 'S', 'W', 'NE', 'NW', 'SE', 'SW', 'IN_NE', 'IN_NW', 'IN_SE', 'IN_SW'].forEach(d =>
      add('season', 'cave_wall_to_floor_' + d.toLowerCase(), TR(caveWall, () => caveFloor(1), d), { priority: 'P2', autotile: 'cavewall>floor' }));
    ['h', 'v', 'corner', 'post'].forEach(k =>
      add('season', 'stone_fence_' + k, recolor(FE(k), { b3: 'n2', b4: 'n3', b1: 'n1', b2: 'n1' }), { priority: 'P2' }));

    // farming (§5)
    [0, 1, 2].forEach(v => add('farm', 'weed_0' + (v + 1), weed(v), { priority: 'P1' }));
    add('farm', 'soil_fertilised_dry', soilFertilised(false), { priority: 'P1' });
    add('farm', 'soil_fertilised_wet', soilFertilised(true), { priority: 'P1' });
    add('farm', 'star_silver', star(false), { priority: 'P1' });
    add('farm', 'star_gold', star(true), { priority: 'P1' });
    add('farm', 'trellis', trellis(), { priority: 'P2' });
    ['apple', 'cherry'].forEach(k => [0, 1, 2, 3, 4].forEach(s =>
      add('farm', `tree_${k}_${s}`, tree(k, s), { priority: 'P2', stageIndex: s })));

    // items & UI (§8)
    ['egg', 'milk'].forEach(i => add('item', 'item_' + i, item(i), { priority: 'P1' }));
    ['fish_bass', 'fish_carp', 'fish_trout', 'fish_boot'].forEach(i => add('item', 'item_' + i, item(i), { priority: 'P1' }));
    ['mushroom', 'berry', 'stick', 'stone'].forEach(i => add('item', 'item_' + i, item(i), { priority: 'P1' }));
    ['fertiliser_basic', 'fertiliser_quality', 'feed'].forEach(i => add('item', 'item_' + i, item(i), { priority: 'P1' }));
    ['ore_copper', 'ore_iron', 'ore_gold'].forEach(i => add('item', 'item_' + i, item(i), { priority: 'P2' }));
    ['energy_full', 'energy_empty', 'coin', 'star', 'weather_sun', 'weather_rain', 'weather_storm', 'weather_snow'].forEach(i =>
      add('ui', 'ui_' + i, ui(i), { priority: 'P1' }));
    ['bubble_talk', 'bubble_exclaim', 'touch_dpad', 'touch_button'].forEach(i => add('ui', 'ui_' + i, ui(i), { priority: 'P2' }));

    // FX (§9 remainder)
    [0, 1, 2, 3].forEach(f => add('fx', 'fx_rain_' + f, fxRain(f), { priority: 'P1', anim: 'fx_rain', frame: f, blended: true }));
    [0, 1, 2, 3].forEach(f => add('fx', 'fx_snow_' + f, fxSnow(f), { priority: 'P1', anim: 'fx_snow', frame: f, blended: true }));
    add('fx', 'fx_puddle', fxPuddle(), { priority: 'P1', blended: true });
    [0, 1, 2].forEach(f => add('fx', 'fx_zzz_' + f, fxZzz(f), { priority: 'P1', anim: 'fx_zzz', frame: f, blended: true }));
    add('fx', 'fx_bobber', fxBobber(), { priority: 'P1' });
    [0, 1, 2].forEach(f => add('fx', 'fx_ripple_' + f, fxRipple(f), { priority: 'P1', anim: 'fx_ripple', frame: f, blended: true }));
    add('fx', 'fx_lightning', fxLightning(), { priority: 'P2', blended: true });
    add('fx', 'fx_lamp_glow', fxLampGlow(), { priority: 'P2', blended: true });

    // free wins: NPC cast as recolours of the farmer rig
    const CAST = {
      villager: { r1: 'g2', r2: 'g3', c1: 'b2', D: 'b1' },
      shopkeeper: { r1: 'p1', r2: 'p2', c1: 'n1', D: 'K', b4: 'w', b3: 'n3' },
      spouse: { r1: 'y1', r2: 'y2', c1: 'p1', D: 'p1', b1: 'r1' },
      child: { r1: 'c2', r2: 'w', c1: 'g2', D: 'g1' }
    };
    Object.entries(CAST).forEach(([who, map]) => {
      add('cast', `${who}_idle_down_0`, recolor(L.farmer({ dir: 'down', pose: 'idle' }), map), { npc: who });
      [0, 1, 2, 3].forEach(f => add('cast', `${who}_walk_down_${f}`,
        recolor(L.farmer({ dir: 'down', pose: 'walk', legs: f, bob: f % 2 ? 0 : 1 }), map),
        { npc: who, anim: `${who}_walk_down`, frame: f }));
    });
    return out;
  }

  Object.assign(L.PAL_FX, { yB: 'rgba(224,178,60,0.35)', yC: 'rgba(224,178,60,0.15)' });

  const api = { world, tree, item, ui, barn, shop, greenhouse };
  if (typeof window !== 'undefined') window.SpriteWorld = api;
  if (typeof globalThis !== 'undefined') globalThis.SpriteWorld = api;
})();
